'use strict';

var chunkNCQUVFG7_js = require('./chunk-NCQUVFG7.js');
var chunk32OAM7MJ_js = require('./chunk-32OAM7MJ.js');
var h = require('clsx');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var h__default = /*#__PURE__*/_interopDefault(h);

var R=({label:e,onChange:m,name:o,value:a,checked:t,onClick:d,inputRef:c,className:f,inline:u=!1,dataTestId:b,"aria-labelledby":C,...g})=>{let n=`${o}-${a}`,s=`label-${n}`,v=`${chunk32OAM7MJ_js.a}-radio-button`,S=h__default.default(v,f,{inline:u,checked:t}),i=chunkNCQUVFG7_js.a(["span","span","span"],[20,20,20]),E={"--mobile-offset":i[0],"--desktop-offset":i[2]};return jsxRuntime.jsxs("div",{style:E,className:S,children:[e&&jsxRuntime.jsx("label",{id:s,htmlFor:n,children:e}),jsxRuntime.jsx("input",{id:n,type:"radio",name:o,className:"input",onChange:m,onClick:d,value:a,checked:t,"aria-checked":t,"aria-labelledby":e?s:C,"data-name":e,"data-testid":b,ref:c,...g})]})},y=R;

exports.a = y;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-JLUXD7O3.js.map